import React from 'react';
import * as _ from 'lodash';
import * as styles from './Masonry.scss';

function Masonry(props) {
  var bricks = props.bricks,
      vertical = props.vertical;
  var items = bricks.length ? _.cloneDeep(bricks) : [];
  return /*#__PURE__*/React.createElement("div", {
    className: vertical ? styles.columnWrap : styles.wrap,
    style: vertical ? {
      columnWidth: 240,
      columnGap: 32
    } : {}
  }, items.map(function (item) {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.brick
    }, item);
  }));
}

Masonry.defaultProps = {
  vertical: false
};
export default Masonry;